import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import api from '@/lib/api';
import { C, EmptyState, FilterSelect, TableShell } from '@/design-system/dna';
import { anoLabel, ETAPA_LABEL } from './shared';

const ALL = 'all';

export function BancoTab() {
  const [fac, setFac] = useState(null);
  const [f, setF] = useState({ etapa: ALL, componente: ALL, dominio: ALL });
  const [items, setItems] = useState(null);
  useEffect(() => { api.get('/dna-mapa/habilidades/facetas').then(({ data }) => setFac(data)).catch(() => setFac({})); }, []);
  useEffect(() => {
    const p = Object.fromEntries(Object.entries(f).filter(([, v]) => v !== ALL));
    api.get('/dna-mapa/habilidades', { params: { ...p, limit: 300 } }).then(({ data }) => setItems(data.items)).catch(() => setItems([]));
  }, [f]);
  const opt = (k, all, map) => [{ value: ALL, label: all }, ...((fac?.[k]) || []).map((v) => ({ value: v, label: map ? map[v] || v : v }))];
  const toolbar = (
    <>
      <FilterSelect id="dna-banco-etapa" value={f.etapa} onChange={(v) => setF({ ...f, etapa: v })} items={opt('etapa', 'Todas as etapas', ETAPA_LABEL)} />
      <FilterSelect id="dna-banco-componente" value={f.componente} onChange={(v) => setF({ ...f, componente: v })} items={opt('componente', 'Todos os componentes')} />
      <FilterSelect id="dna-banco-dominio" value={f.dominio} onChange={(v) => setF({ ...f, dominio: v })} items={opt('dominio', 'Todos os domínios')} />
    </>
  );
  return (
    <TableShell title={`Banco pedagógico · referência BNCC (${items?.length ?? '…'})`} toolbar={toolbar} testid="dna-banco"
      footer="Organizado por etapa, ano, área, componente, domínio e pré-requisito. Itens contextualizados pelos professores aparecem marcados.">
      {!items ? <p className="flex items-center gap-2 p-6 text-sm" style={{ color: C.muted }}><Loader2 className="h-4 w-4 animate-spin" /> Carregando…</p>
        : !items.length ? <div className="p-5"><EmptyState title="Nada encontrado" testid="dna-banco-vazio">Ajuste os filtros.</EmptyState></div>
          : (
            <div className="divide-y" style={{ borderColor: C.line }}>
              {items.map((s) => (
                <div key={s.id} className="grid gap-1 px-5 py-3 md:grid-cols-[130px_1fr]" data-testid={`dna-banco-${s.codigo}`}>
                  <div><p className="font-extrabold" style={{ color: C.purple }}>{s.codigo}</p><p className="text-[11px]" style={{ color: C.muted }}>{ETAPA_LABEL[s.etapa]} · {anoLabel(s.etapa, s.ano)}</p></div>
                  <div><p className="text-[11px] font-bold uppercase tracking-wider" style={{ color: C.muted }}>{s.componente} · {s.dominio}{s.kind === 'custom' ? ' · contextualizado' : ''}</p>
                    <p className="text-[13px]" style={{ color: C.ink }}>{s.habilidade}</p>
                    {s.pre_requisitos?.length > 0 && <p className="text-[11.5px]" style={{ color: C.muted }}>Pré-requisitos: {s.pre_requisitos.join(', ')}</p>}</div>
                </div>
              ))}
            </div>
          )}
    </TableShell>
  );
}
